import o from "./SidebarElement.vue2.js";
import "./SidebarElement.vue3.js";
import t from "../../_virtual/_plugin-vue_export-helper.js";
const m = /* @__PURE__ */ t(o, [["__scopeId", "data-v-ae5d7895"]]);
export {
  m as default
};
